import { render, staticRenderFns } from "./UnitInput.vue?vue&type=template&id=98c51728&scoped=true"
import script from "./UnitInput.vue?vue&type=script&lang=js"
export * from "./UnitInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c51728",
  null
  
)

export default component.exports